import React, { useEffect, useState } from 'react';
import axios from 'axios';

import "./FlipBox.css";
import TextAnimation from './TextAnimation';

const FlipCard = () => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/tickets/`) 
      .then((response) => {
        setTickets(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setError("خطا در بارگذاری !");
        setLoading(false);
      });
  }, []);
  if (loading) return (
    <div className='grid grid-cols-1 md:grid-cols-3 gap-2'>
      <div role="status" className="p-2 flex items-center justify-center h-56 max-w-sm bg-slate-700 rounded-xl animate-pulse">
          <svg className="w-10 h-10 text-slate-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 20">
          <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z"/>
          <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM9 13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2Zm4 .382a1 1 0 0 1-1.447.894L10 13v-2l1.553-1.276a1 1 0 0 1 1.447.894v2.764Z"/>
        </svg>
          <span className="sr-only">Loading...</span>
      </div>
      <div role="status" className="p-2 flex items-center justify-center h-56 max-w-sm bg-slate-700 rounded-xl animate-pulse">
          <svg className="w-10 h-10 text-slate-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 20">
          <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z"/>
          <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM9 13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2Zm4 .382a1 1 0 0 1-1.447.894L10 13v-2l1.553-1.276a1 1 0 0 1 1.447.894v2.764Z"/>
        </svg>
          <span className="sr-only">Loading...</span>
      </div>
      <div role="status" className="p-2 flex items-center justify-center h-56 max-w-sm bg-slate-700 rounded-xl animate-pulse">
          <svg className="w-10 h-10 text-slate-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 20">
          <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z"/>
          <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM9 13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2Zm4 .382a1 1 0 0 1-1.447.894L10 13v-2l1.553-1.276a1 1 0 0 1 1.447.894v2.764Z"/>
        </svg>
          <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
  if (error) return <p>{error}</p>;
  return (
    <>
    <div className='h-[4vh]'></div>
    <TextAnimation id='text-blit' textStyle='text-3xl sm:text-4xl md:text-5xl' text='رزرو حضور'  />
    <h3 className="text-base p-4" style={{color: 'rgb(132, 204, 22)'}}>با رزروها آشنا شو</h3>
    <div className="box-container">
    
      
      {/* Third Box */}
      {tickets.map((ticket) => (
      <div key={ticket.id} className="box-item mx-2 rtl text-justify">
  <div className="flip-box relative ">
    {/* Front Side */}
    <div
      className="flip-box-front text-center border-2 border-gray-600  "
      style={{
        backgroundImage: `url(${ticket.image})`,
        backgroundColor: 'rgb(16, 16, 16)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Transparent Black Layer */}
      <div
        className="absolute inset-0 bg-black opacity-50 rounded-[84px]"
      ></div>
      
      <div className="inner color-white relative z-10">
        <h3 className="text-2xl mb-3">{ticket.title}</h3>
        <p className="text-xl mb-8">{ticket.front_description}</p>
        <svg className="w-8 h-8" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#ffffff" stroke="#ffffff">
         <path d="M2.639 15.992c0 7.366 5.97 13.337 13.337 13.337s13.337-5.97 13.337-13.337-5.97-13.337-13.337-13.337-13.337 5.97-13.337 13.337zM28.245 15.992c0 6.765-5.504 12.27-12.27 12.27s-12.27-5.505-12.27-12.27 5.505-12.27 12.27-12.27c6.765 0 12.27 5.505 12.27 12.27z" fill="#ffffff"> </path> <path d="M19.159 16.754l0.754-0.754-6.035-6.035-0.754 0.754 5.281 5.281-5.256 5.256 0.754 0.754 3.013-3.013z" fill="#ffffff"> </path>
         </svg>
      </div>
    </div>
    
    {/* Back Side */}
    <div
      className="flip-box-back text-center"
      style={{
        backgroundColor: '#031626',
      }}
    >
      <div className="inner color-white">
        <h3 className="text-2xl mb-3">{ticket.title}</h3>
        <p className='text-xl mb-8'>{ticket.back_description}</p>
        <a href={ticket.purchase_link} className="text-xl flip-box-button mt-3">درخواست رزرو</a>
      </div>
    </div>
  </div>
</div>
))}
 
    </div>
    <div className='h-[4vh]'></div>
    </>
  );
};

export default FlipCard;
